export const FABRIC_BG ={
    STRECH:'bg-strech',
    TENSION:'bg-tension',
    FLAG:'bg-flag',
    BACKLIT:'bg-backlit',
    RESHET:'bg-reshet',
    BLOCKOUT:'bg-blockout',
    '600D':'bg-600d',
    'SC':'bg-SC',
    'T2':'bg-T2'
  }
  

  